<template>
    <div class="resetContain">
    <div class="resetPwd">
        <p style="padding-bottom: 20px;color: #333333;font-size: 18px">重置密码</p>
            <el-form style="padding: 0 40px" :model="pwdForm" :rules="rules" ref="pwdForm" label-width="110px">
                <el-form-item label="姓名：" prop="userName">
                    <el-input v-model="pwdForm.userName" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="身份证号码：" prop="idCard">
                    <el-input v-model="pwdForm.idCard" placeholder="请输入身份证号码"></el-input>
                </el-form-item>
                <el-form-item label="手机号码：" prop="phoneNum">
                    <el-input v-model="pwdForm.phoneNum" placeholder="请输入手机号码" @input="changeInput()"></el-input>
                </el-form-item>
                <!--<el-form-item label="验证码：" prop="yzmCode">-->
                <!--<div style="display: flex;justify-content: space-between">-->
                <!--<el-input placeholder="请输入验证码" style="margin-right: 20px"-->
                <!--v-model="pwdForm.yzmCode">-->
                <!--</el-input>-->
                <!--<el-image @click="refreshCode" style="width: 130px;height: 40px;flex-shrink: 0" :src="pwdForm-->
                <!--.codeUrl"></el-image>-->
                <!--</div>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="短信验证码：" prop="msgCode">-->
                <!--<div style="display: flex;justify-content: space-between">-->
                <!--<el-input placeholder="请输入短信验证码" style="margin-right: 20px"-->
                <!--v-model="pwdForm.msgCode">-->
                <!--</el-input>-->
                <!--<el-button v-if="sendMsgCode" :disabled=!pwdForm.msgEnable-->
                <!--style="width:120px;height:40px;font-size:14px;background:#eee;flex-shrink: 0"-->
                <!--@click="getMsgCode()">获取短信验证码-->

                <!--</el-button>-->
                <!--<el-button v-if="!sendMsgCode"-->
                <!--style="width:140px;height:40px;font-size:12px;background:#eee;;flex-shrink: 0"-->
                <!--disabled><span>{{countTime}}</span>秒后重新获取验证码-->

                <!--</el-button>-->
                <!--</div>-->
                <!--</el-form-item>-->
                <el-form-item label="登录密码：" prop="password">
                    <el-input type="password" v-model="pwdForm.password" placeholder="必填，6-20个字符"></el-input>
                </el-form-item>
                <el-form-item label="确认密码：" prop="_password">
                    <el-input type="password" v-model="pwdForm._password" placeholder="必填，6-20个字符，与密码一致"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDlg()" class="closePwd">取 消</el-button>
                <el-button type="primary" @click="sbmDlg()" class="editPwd">修改密码</el-button>
            </div>
    </div>
    </div>
</template>

<script>
    import qs from 'qs';
    import {constyjyp} from '../../../core/constStatic';
    import cryptoMd5 from 'crypto-md5';

    export default {
        components: {},
        watch: {
            'pwdForm.yzmCode': function (val, oldval) {
                console.log(val);
                if (val.length === 4) {
                    this.checkCode();
                }
            }
        },
        data() {
            return {
                timer: '',
                pwdForm: {
                    msgEnable: false,
                    codeCheckUrl: '',
                    codeUrl: '',
                    userName: '',
                    idCard: '',
                    phoneNum: '',
                    yzmCode: '',
                    msgCode: '',
                    password: '',
                    _password: '',
                },
                rules: {},
                sendMsgCode: true,
                countTime: 0
            }
        },
        created() {
            let paswValidate = (rule, value, callback) => {
                var reg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,16}$/;
                if (reg.test(value)) {
                    callback();
                } else {
                    callback(new Error('请输入长度在6到16个字符的数字和字母组合'));
                }
            };
            let secdpaswValidate = (rule, value, callback) => {
                if (this.pwdForm.password !== value) {
                    callback(new Error('两次输入的密码不一致'));
                } else {
                    callback();
                }
            };
        this.rules = {
            userName: [
                {required: true, message: '请输入姓名', trigger: 'blur'},
                {min: 2, max: 6, message: '长度在 2 到 6 个字符', trigger: 'blur'}
            ],
            idCard: [
                {required: true, message: '请输入身份证号码', trigger: 'blur'},
            ],
            phoneNum: [
                {required: true, message: '请输入手机号码', trigger: 'blur'},
                {min: 11, max: 11, message: '长度 11 个字符', trigger: 'blur'}
            ],
//                    yzmCode: [
//                        {required: true, message: '请输入验证码', trigger: 'blur'},
//                        {min: 4, max: 4, message: '长度 4 个字符', trigger: 'blur'}
//                    ],
//                    msgCode: [
//                        {required: true, message: '请输入短信验证码', trigger: 'blur'},
//                        {min: 5, max: 5, message: '长度 5 个字符', trigger: 'blur'}
//                    ],
            password: [
                {required: true, message: '请输入新的密码', trigger: 'blur'},
                {validator: paswValidate, trigger: 'blur'}
            ],
            _password: [
                {required: true, message: '请重复新的密码', trigger: 'blur'},
                {validator: paswValidate, trigger: 'blur'},
                {validator: secdpaswValidate, trigger: 'blur'}
                ]
        }
            },
        mounted () {
            console.log(this.$route.query);
        },
        methods: {
            closeDlg(){
                let from = this.$route.query.f||'';
                if(from){
                    window.location = from;
                } else {
                    this.$router.back();
                }
            },
            checkCode(){
                this.axios.get(this.pwdForm.codeCheckUrl, {params: {'imageCode': this.pwdForm.yzmCode}}).then(res => {
                    console.log(res);
                    if (res.data.status != 0) {
                        this.pwdForm.msgEnable = false;
                        this.$message({'message': res.data.message, 'type': 'error'});
                    } else {
                        this.pwdForm.msgEnable = true;
                    }

                }).catch(err => {
                    console.log(err);
                    this.refreshCode();
                    this.$message({'message': err.message || '服务器错误', 'type': 'error'});
                });
            },
            sbmDlg(){
                this.$refs['pwdForm'].validate((valid) => {
                    if (valid) {
                        this.comitDataToServe();
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });

            },
            comitDataToServe(){
                let parm = {
                    realName: this.pwdForm.userName,
                    papersNumber: this.pwdForm.idCard,
                    mobilePhone: this.pwdForm.phoneNum,
                    smsCode: this.pwdForm.msgCode,
                    password: cryptoMd5(this.pwdForm.password,'hex')
                };
                let from = this.$route.query.f||'';
                this.axios.post(this.apis.login.modifyPassword, parm).then(res => {
                    if(res.data.status == 0){
                        this.$message({'message':'重置密码成功!','type':'success',onClose:function () {
                            if(from){
                                window.location = from;
                            } else {
                                this.$router.back();
                            }
                        }});

                    }else{
                        this.$message({'message':res.data.message,'type':'error'});
                    }
                }).catch(err => {

                });
            },
            getMsgCode(){
                // 获取短信验证码
                if (this.pwdForm.phoneNum && this.pwdForm.phoneNum.length === 11) {
                    this.sendMsgCode = false;
                    this.countTime = 60;
                    this.timer = setInterval(() => {
                        this.countTime--;
                        if (this.countTime <= 0) {
                            this.sendMsgCode = true;
                            clearInterval(this.timer);
                        }
                    }, 1000);
                    let url1 = this.appUtils.getSignWithUrl(this.apis.login.getMsgCode + '/sms');
                    let url = url1 + '&phone=' + this.pwdForm.phoneNum;
                    this.axios.get(url).then((res) => {
                        console.log(res);
                    }).catch((err) => {
                        console.log(err);
                    })
                } else {
                    this.$message.error('请输入正确的手机号码');
                }
            },
            changeInput(){
                console.log(this.pwdForm.phoneNum);
            },
            refreshCode() {
                let url = this.appUtils.getSignWithUrl(this.apis.login.getMsgCode + '/imageUrl');
                this.axios.get(url).then(res => {
                    debugger
                    this.pwdForm.codeUrl = res.data.data.imageURL;
                    this.pwdForm.codeCheckUrl = res.data.data.imageCheckURL;
                }).catch(err => {
                    console.log(err);
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    @import './base.css';
    // TODO identify
    .resetContain{
        display: flex;
        height: 100vh;
        justify-content: center;
        align-items: center;
    }
    .resetPwd {
        background-color: white;
        padding: 30px 0;
        width: 500px;
        box-shadow:0px 12px 38px 0px rgba(0, 0, 0, 0.1);
        border-radius:8px;
        .editPwd {
            width: 100px;
            height: 38px;
        }
        .closePwd {
            width: 100px;
            height: 38px;
            background: #eee;
        }
    }
</style>
